"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireWildcard(require("../../Icon"));

var _utils = require("../../../utils");

var _PropTypes$shape2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function RowCell(props) {
  var row = props.row,
      data = props.data,
      index = props.index,
      level = props.level,
      _props$column = props.column,
      hidden = _props$column.hidden,
      render = _props$column.render,
      sorter = _props$column.sorter,
      sortable = _props$column.sortable,
      className = _props$column.className,
      selection = _props$column.selection,
      filterable = _props$column.filterable,
      onCell = _props$column.onCell,
      expanded = props.expanded,
      onExpand = props.onExpand;
  if (hidden) return null;
  var cellPops = typeof onCell === 'function' ? onCell(row, index) : {};
  var selectComponent = (0, _react.useMemo)(function () {
    return typeof selection === 'function' ? selection(data, row) : null;
  }, [selection, data, row]);
  var expandIcon = (0, _react.useMemo)(function () {
    return index === 0 && row.children && row.children.length > 0;
  }, [row, index]);
  var expandRender = (0, _react.useCallback)(function (render) {
    return level > 0 && index === 0 ? /*#__PURE__*/_react.default.createElement("div", {
      className: "expand-cell"
    }, render) : render;
  }, [level, index]);
  var classNameCell = (0, _utils.getClassNames)(className, {
    'cell-sortable': sortable || sorter
  }, {
    'cell-filterable': filterable
  }, {
    'cell-row-selection': selectComponent
  });
  return /*#__PURE__*/_react.default.createElement("td", _extends({
    role: "cell",
    className: classNameCell
  }, cellPops), selectComponent, expandIcon && /*#__PURE__*/_react.default.createElement("span", {
    className: "expand-icon"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    onClick: function onClick() {
      return cellPops.onClick === undefined ? onExpand() : {};
    },
    type: expanded ? _Icon.ICON_TYPE_MINUS : _Icon.ICON_TYPE_PLUS
  })), expandRender(render ? render(data, row, index) : /*#__PURE__*/_react.default.createElement("span", {
    className: "table-cell"
  }, data)));
}

RowCell.propTypes = {
  row: _propTypes.default.shape((_PropTypes$shape2 = {}, _defineProperty(_PropTypes$shape2, _propTypes.default.string, _propTypes.default.any), _defineProperty(_PropTypes$shape2, "children", _propTypes.default.arrayOf(_propTypes.default.shape(_defineProperty({}, _propTypes.default.string, _propTypes.default.any)))), _PropTypes$shape2)),
  data: _propTypes.default.oneOf(_propTypes.default.string, _propTypes.default.shape),
  level: _propTypes.default.number.isRequired,
  index: _propTypes.default.number.isRequired,
  column: _propTypes.default.shape({
    hidden: _propTypes.default.bool,
    render: _propTypes.default.func,
    sortable: _propTypes.default.bool,
    className: _propTypes.default.string,
    sorter: _propTypes.default.func,
    selection: _propTypes.default.func,
    filterable: _propTypes.default.bool,
    onCell: _propTypes.default.func
  }),
  expanded: _propTypes.default.bool,
  scrollable: _propTypes.default.bool,
  onExpand: _propTypes.default.func
};
RowCell.defaultProps = {
  row: {
    children: undefined
  },
  data: null,
  column: {
    hidden: false,
    render: undefined,
    sortable: false,
    className: undefined,
    filterable: false,
    sorter: undefined,
    selection: function selection() {},
    onCell: function onCell() {
      return {};
    }
  },
  expanded: false,
  scrollable: false,
  onExpand: function onExpand() {}
};
var _default = RowCell;
exports.default = _default;